<template>
  <i
    :class="iconClasses"
    :data-cy="`ds-icon--${props.icon}`"
  >
    <component
      :is="iconSvg"
      v-if="!!iconSvg"
      viewBox="0 0 16 16"
    />
  </i>
</template>

<script setup lang="ts">
import { DS_ICON_APPEARANCES, DS_ICON_SIZES } from "@/src/design_system/primitives/icon/types";
import { computed } from "vue";
import { getSvgComponentLoader } from "@/src/design_system/primitives/icon/utils";
import { DSIconProps } from "@/src/design_system/primitives/icon/types/props";
import { DS_ICON_CLASSES } from "@/src/design_system/primitives/icon/constants/classes";

const props = withDefaults(defineProps<DSIconProps>(), {
  size: DS_ICON_SIZES.Medium,
  appearance: DS_ICON_APPEARANCES.Outlined,
  spin: false,
});

const iconSvg = computed(() => {
  return getSvgComponentLoader(props.icon, props.appearance);
});

const iconClasses = computed(() => {
  const classes: string[] = [DS_ICON_CLASSES.Base];

  classes.push(`${DS_ICON_CLASSES.Base}--${props.size}`);
  if (props.spin) classes.push(DS_ICON_CLASSES.Spin);
  return classes;
});
</script>
